<template>
  <div class="share-layer-box">
    <van-overlay class="share-box" z-index="9999" :show="shareShow" @click="closeFun">
      <div class="wrapper" >
        <img class="share-img" :src="imageView('https://images.snsports.cn/FmvQf6AVN9k4UjIa2Y-JjdvoUjbk')" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
// import Vue from 'vue'
import variables from '@/assets/css/variables.scss'
import { QNImageUtil } from "@/utils";
import Vue from 'vue';
import { Overlay } from 'vant';

Vue.use(Overlay);
export default {
  props: {
    shareShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    variables() {
      return variables
    }
  },
  mounted () {

  },
  methods: {
    closeFun() {
      this.$emit('close')
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    }
  }
}
</script>
<style lang='scss' scoped>
 .share-layer-box {
   .share-box {
    .wrapper{
      position: relative;
      text-align: left;
      .share-img{
        position: absolute;
        //top: 40px;
        //left: 50%;
        //transform: translateX(-50%);
        width: 100vw;
        height: 100vh;
      }
    }
  }
 }
</style>
